import { eventListenerOptions } from '@spinnwerk/polyfills';

/**
 * Should not be called directly.
 * @see {@link preventMobileZoom}
 *
 * @param {NodeList} inputs
 * @private
 */
export function initPreventMobileZoom(inputs) {
    let viewportMeta = document.querySelector('meta[name="viewport"]'),
        viewportMetaContent = viewportMeta.getAttribute('content'),
        zoomEnableTimeout;

    function fixZoom() {
        clearTimeout(zoomEnableTimeout);
        viewportMeta.setAttribute('content', viewportMetaContent + ',maximum-scale=1');
    }

    function releaseZoom() {
        // use a timeout to maintain zoom state while switching to another input -> better UX
        zoomEnableTimeout = setTimeout(() => {
            viewportMeta.setAttribute('content', viewportMetaContent);
        }, 100);
    }

    inputs.forEach(input => {
        input.addEventListener('focus', fixZoom, eventListenerOptions({ passive: true }));
        input.addEventListener('touchstart', fixZoom, eventListenerOptions({ passive: true }));

        input.addEventListener('blur', releaseZoom, eventListenerOptions({ passive: true }));
    });
}
